// data.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function data(apiData = [], onEdit) {
  return {
    columns: [
      { Header: "Style Name", accessor: "title", align: "left" },
      { Header: "Description", accessor: "description", align: "left" },
      { Header: "Active", accessor: "isactive", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: apiData.map((item) => ({
      title: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.stylename ?? "-"}
        </MDTypography>
      ),
      description: (
        <MDTypography variant="caption" color="text">
          {item.description ?? "-"}
        </MDTypography>
      ),
      isactive: (
        <MDBox display="flex" justifyContent="center">
          <MDTypography
            variant="caption"
            fontWeight="medium"
            color={item.isactive ? "success" : "error"}
          >
            {item.isactive ? "Yes" : "No"}
          </MDTypography>
        </MDBox>
      ),
      action: (
        <MDTypography
          component="a"
          href="#"
          variant="caption"
          color="info"
          fontWeight="medium"
          onClick={(e) => {
            e.preventDefault();
            onEdit(item);
          }}
        >
          Edit
        </MDTypography>
      ),
    })),
  };
}
